import React, { Component } from 'react';

class Button extends Component {
    
    render() {
        
        return (
            <div className="nlf-viewer-block nlf-viewer-button">
                <a href={this.props.data.url} {...this.props.data.targetBlank && {'target' : '_blank'} } className="btn btn-default"><span>{this.props.data.labelButton}</span></a>
            </div>
        )
        
    }
}

export default Button


// WEBPACK FOOTER //
// ./src/Button.js